import { render } from "./create-personal.vue?vue&type=template&id=5d6e20af&scoped=true"
import script from "./create-personal.vue?vue&type=script&lang=js"
export * from "./create-personal.vue?vue&type=script&lang=js"

import "./create-personal.vue?vue&type=style&index=0&id=5d6e20af&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6e20af"]])

export default __exports__